import {
    EnumInfoUTypes,
    EnumLanguages,
    EnumMFAMethods,
    EnumNotificationDeliveryOptions,
    EnumNotificationStatuses,
    EnumPopupShowStatuses,
    EnumSystemOptionDataTypes,
    EnumSystemOptions,
    EnumUserLoginStatus,
    HistoryEventTypesEnum
} from '@core/framework/sysenums.enum';

export const Resources_HE =
{
    Pages:
    {
        login: 'התחברות למערכת',
        logout: 'התנתק',
        usersactivitystatus: 'מצב פעילות משתמשים',
        notificationshistory: 'דוח התראות שנשלחו',
        notification_servers: 'שרתי התראות',
        notification_templates: 'תבניות להתראות',
        notifications: 'התראות',
        system_options: 'הגדרות מערכת',
        user_login_history: "דוח התחברויות משתמשים",
        request_history: "היסטוריית בקשות",

        NotificationViewComponent: 'התראה שנשלחה',
        PrintBoxDialogComponent: 'הדפסה',
        SignBoxDialogComponent: 'חתימה על מסמך',
        ImageBoxDialogComponent: 'תמונה',
        PhotoBoxDialogComponent: 'צילום',
        PasswordManageComponent: 'ניהול פרטי משתמש',
        UsersActivityStatusComponent: 'מצב פעילות משתמשים',
        NotificationsHistoryComponent: 'דוח התראות שנשלחו',
        PreviewDialogComponent: 'תצוגה מקדימה',
        NotificationServerComponent: 'שרת התראות',
        NotificationServerListComponent: 'שרתי התראות',
        NotificationTemplateListComponent: 'תבניות להתראות',
        NotificationTemplateComponent: 'תבנית התראה',
        HtmlBoxDialogComponent: 'עורך HTML',
        NotificationTestDialogComponent: 'בדיקת התראות',
        NotificationPreviewDialogComponent: 'תצוגה מקדימה של התראות',
        SystemOptionsComponent: 'הגדרות מערכת',
        AddSystemOptionDialogComponent: 'הוסף הגדרה',
        BarcodeBoxDialogComponent: 'סרוק ברקוד/QR-code',
        UserLoginHistoryComponent: "דוח התחברויות משתמשים",
        RequestHistoryListComponent: "היסטוריית בקשות",
        RequestHistoryComponent: "בקשה",
        WelcomeUserDialogComponent: "הודעת ברוכים הבאים",
        HistoryViewComponent: 'היסטוריית שינוים'
    },
    Lists:
    {
        Languages:
            [
                {
                    Value: EnumLanguages.Hebrew,
                    Text: "עברית/Hebrew"
                },
                {
                    Value: EnumLanguages.English,
                    Text: "אנגלית/English"
                },
            ],

        NotificationDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: "אימייל",
            },
            {
                Value: EnumNotificationDeliveryOptions.Phone,
                Text: "הודעת SMS"
            }
        ],
        NotificationTypes: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: "אימייל",
                SortOrder: 1,
                index: 0,
                text: "אימייל",
                Name: EnumNotificationDeliveryOptions.Email
            },
            {
                Value: EnumNotificationDeliveryOptions.Phone,
                Text: "הודעת SMS",
                SortOrder: 2,
                index: 1,
                text: "הודעת SMS",
                Name: EnumNotificationDeliveryOptions.Phone
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'התראה באפליקציה',
                SortOrder: 3,
                index: 2,
                text: 'התראה באפליקציה',
                Name: EnumNotificationDeliveryOptions.PushMessage
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                SortOrder: 4,
                index: 3,
                text: 'WhatsApp',
                Name: EnumNotificationDeliveryOptions.WhatsApp
            }
        ],
        NotificationStatuses:
            [
                {
                    Value: EnumNotificationStatuses.Draft,
                    Text: "טיוטה"
                },
                {
                    Value: EnumNotificationStatuses.Sending,
                    Text: "שליחה"
                },
                {
                    Value: EnumNotificationStatuses.Failure,
                    Text: "נכשל"
                },
                {
                    Value: EnumNotificationStatuses.Sent,
                    Text: "נשלח"
                },
            ],
        NotificationPredefinedSmtpServers: [
            {
                Text: "Office 365",
                SMTPServer: "smtp.office365.com",
                SMTPPort: 587,
                SMTPUseSSL: true
            },
            {
                Text: "Gmail",
                SMTPServer: "smtp.gmail.com",
                SMTPPort: 111,
                SMTPUseSSL: true
            },
            {
                Text: "SendGrid",
                SMTPServer: "smtp.sendgrid.com",
                SMTPPort: 111,
                SMTPUseSSL: false
            }
        ],
        NotificationPredefinedSmsServers: [
            {
                Text: "InforU",
                SMSEndpoint: "https://uapi.inforu.co.il/SendMessageXml.ashx",
                SMSToken: 111,
                SMSEndPointIsInforU: EnumInfoUTypes.InforU
            },
            {
                Text: "Unicell",
                SMSEndpoint: "http://api.soprano.co.il/",
                SMSToken: 222,
                SMSEndPointIsInforU: EnumInfoUTypes.Unicell
            }
        ],
        MFAMethods:
            [
                {
                    Value: EnumMFAMethods.None,
                    Text: "ללא"
                },
                {
                    Value: EnumMFAMethods.Email,
                    Text: "מייל"
                },
                {
                    Value: EnumMFAMethods.SMS,
                    Text: "SMS"
                }
            ],
        ExportMenuItems: [
            {
                SortOrder: 0,
                Value: 1,
                Text: "אקסל"
            },
            {
                SortOrder: 1,
                Value: 2,
                Text: "הדפס"
            }
        ],
        PopupShowStatuses: [
            {
                Value: EnumPopupShowStatuses.None,
                Text: "ללא"
            },
            {
                Value: EnumPopupShowStatuses.ToShow,
                Text: "הצג"
            },
            {
                Value: EnumPopupShowStatuses.Showed,
                Text: "הוצג"
            }
        ],
        InfoUTypes: [
            {
                Value: EnumInfoUTypes.Unicell,
                Text: "Unicell"
            },
            {
                Value: EnumInfoUTypes.InforU,
                Text: "InforU"
            }
        ],
        SystemOptions: [
            {
                Value: EnumSystemOptions.AppNameHE,
                Text: 'שם בעברית'
            }, {
                Value: EnumSystemOptions.AppNameEN,
                Text: 'שם באנגלית'
            }, {
                Value: EnumSystemOptions.AppURL,
                Text: 'קישור למערכת'
            }, {
                Value: EnumSystemOptions.SessionTimeout,
                Text: 'משך זמן לניתוק סשן, דקות'
            }, {
                Value: EnumSystemOptions.SessionExpiry,
                Text: 'משך זמן להזדהות מחדש, דקות'
            }, {
                Value: EnumSystemOptions.EnableRequestLogging,
                Text: 'אפשר בקשת גישה'
            }, {
                Value: EnumSystemOptions.EnableRemoteLogging,
                Text: 'אפשר חיבור מרחוק'
            }, {
                Value: EnumSystemOptions.ShowExpiredTimeoutAlert,
                Text: 'הצג תוקף התחברות למערכת'
            }, {
                Value: EnumSystemOptions.ShowAlmostExpiredTimeoutAlert,
                Text: 'הצג תוקף התחברות למערכת שעומד לפוג'
            }, {
                Value: EnumSystemOptions.IsSupportedCredentialsManagement,
                Text: 'תמיכה בניהול אישורים'
            }, {
                Value: EnumSystemOptions.IsSupportedUserWelcome,
                Text: 'תמיכה בהקמת משתמשים חדשים'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordChange,
                Text: 'תמיכה בשינוי סיסמא לאחר הזדהות'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordRecovery,
                Text: 'תמיכה בשחזור סיסמא ששכחתי'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByOTP,
                Text: 'אפשר חיבור ב-OTP'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByPassword,
                Text: 'אפשר חיבור באמצעות סיסמא'
            }, {
                Value: EnumSystemOptions.IsAutoCreateCredentials,
                Text: 'צור משתמש במערכת באופן אוטומטי בחיבור ראשון דרך OTP'
            }, {
                Value: EnumSystemOptions.AutoCreateCredentialsType,
                Text: 'סוג משתמש ליצירה אוטומטית'
            }, {
                Value: EnumSystemOptions.IsRequireTaxNumberForOTP,
                Text: 'בדוק מספר ח.פ בהזדהות עם OTP'
            }, {
                Value: EnumSystemOptions.PasswordChangeIntervalDays,
                Text: 'תדירות החלפת סיסמה (ימים)'
            }, {
                Value: EnumSystemOptions.PasswordComplexityLen,
                Text: 'מורכבות סיסמה - מספר תווים מינימאלי'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinChars,
                Text: 'מורכבות סיסמה - מספר אותיות מינימאלי'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinDigits,
                Text: 'מורכבות סיסמה - מספר ספרות מינימאלי'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptBeforeLock,
                Text: 'מספר ניסיונות התחברות כושלים לפני נעילת משתמש'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptsCheckIntervalMinutes,
                Text: 'חלון זמן לבדיקת מספר ניסיונות התחברות, דקות'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptLockouIntervalMinutes,
                Text: 'משך נעילת משתמש לאחר ניסיון התחברות כושל, דקות'
            }, {
                Value: EnumSystemOptions.XFrameOptions,
                Text: 'אפשרויות חסימת XFrame'
            }, {
                Value: EnumSystemOptions.IsDeployedBehindLoadBalancer,
                Text: 'התקנה מאחורי Load Balancer או Proxy'
            }
        ],
        UserLoginStatuses: [
            {
                Value: EnumUserLoginStatus.All,
                Text: "הכל"
            },
            {
                Value: EnumUserLoginStatus.Success,
                Text: "הצליח"
            },
            {
                Value: EnumUserLoginStatus.Failure,
                Text: "נכשל"
            }
        ],
        IsSuccessStatuses: [
            {
                Value: true,
                Text: "הצליח"
            },
            {
                Value: false,
                Text: "נכשל"
            }
        ],
        HistoryEventTypesEnum: [
            {
                Value: HistoryEventTypesEnum.FieldChange,
                Text: "שינוי ערך"
            },
            {
                Value: HistoryEventTypesEnum.RowAdded,
                Text: "נוספה שורה"
            },
            {
                Value: HistoryEventTypesEnum.RowDeleted,
                Text: "שורה נמחקה"
            },
            {
                Value: HistoryEventTypesEnum.Special,
                Text: "Special"
            }
        ]
    },
    Translations:
    {
        lblLanguage: "שפה",
        lblUserName: "שם משתמש",
        lblPassword: "סיסמה",
        titleLogin: "כניסה למערכת",
        btnLogin: "כניסה למערכת",
        btnLogout: 'התנתק',
        btnChangePassword: 'שנה סיסמה',
        btnRecoverPassword: 'שכחתי סיסמה',
        lblSaveCredentials: 'שמור פרטי הזדהות',
        titleLogout: "נותקת מהמערכת",
        titleLogoutLong: "נותקת מהמערכת בהצלחה.",
        titleLogoutLast: "הינך מועבר למסך הכניסה",
        titleSessionExpiredTitle: "ניתוק עקב חוסר פעילות",
        titleSessionExpired: "נותקת מהמערכת עקב חוסר פעילות או שינוי בפרטי המשתמש בשרת. אנא בצע כניסה מחודשת למערכת",
        titleChangePasswordTitle: "שינוי סיסמה",
        titleChangePassword: "בחר סיסמה חדשה העומדת בדרישות המורכבות שהוגדרו על ידי מנהל המערכת",
        titleChangePasswordTitle2: "שינוי סיסמה שפג תוקפה",
        titleException: "שגיאת מערכת",
        titleExceptionLong: "אירעה שגיאה בלתי צפויה במערכת\nפרטי השגיאה מופיעים מטה - אנא העבר אותם למנהל המערכת",
        titleComingSoonTitle: "בקרוב! גם זה יפותח..",
        titlePasswordChanged: 'הסיסמה הוחלפה בהצלחה. אנא השתמך בסיסמה החדשה על מנת להכנס מחדש למערכת',
        titleIdentification: 'הזדהות',
        titlePasswordEntry: 'הזנת סיסמה חדשה',
        titleRecoverPasswordTitle: 'שחזור סיסמה שנשכחה',
        titleWelcomePasswordTitle: 'כניסה ראשונית למערכת',
        titleRecoverPassword1: 'הקלד את שם המשתמש',
        titleRecoverPassword2: 'באפשרותך לשחזר סיסמה שנשכחה, אם יש לך גישה לאימייל או לטלפון שמוגדר בחשבון משתמש שלך',
        titleRecoverPassword3: "אנא הזן סיסמה חדשה. יש להעתיק ולהזין אותו מטה על מנת לעבור לשחזור הסיסמה",
        titleRecoverPassword4: 'בחר סיסמה חדשה העומדת בדרישות המורכבות שהוגדרו על ידי מנהל המערכת',
        titleWelcomePassword2: 'ברוך הבא למערכת. יש להזין את שם המשתמש והקוד הסודי שנשלח אלייך על מנת לעבור לבחירת הסיסמה',
        titleWelcomePassword3: "בחר סיסמה חדשה העומדת בדרישות המורכבות שהוגדרו על ידי מנהל המערכת. סיסמה זו תשמש אותך מעכשיו על מנת להיכנס למערכת",
        btnReEntry: "כניסה מחודשת",
        genOK: 'אישור',
        genYes: "כן",
        genNo: "לא",
        genCancel: "ביטול",
        genNoData: "אין נתונים להצגה",
        genPrint: 'הדפס',
        genSign: 'חתום',
        genReset: 'נקה',
        genTakePhoto: 'צלם',
        genSavePhotos: 'שמור תמונות',
        genDownload: 'הורד',
        msgSignHere: 'אנא צייר את חתימתך בתוך המלבן',
        msgSignatureRequired: 'הינך חייב לחתום כאן על מנת להמשיך',
        msgPasswordsDontMatch: 'הסיסמאות לא תואמות, אנא נסה שנית',
        errorNetwork: "שגיאת תקשורת לשרת - בדוק את חיבור הרשת",
        errorSessionExpired: "נותקת עקב חוסר פעילות",
        errorUserInvalid: "פרטי המשתמש השתנו. אנא התחבר מחדש למערכת",
        errorNotInitialized: "לא ניתן להכנס למערכת כיוון שלא נטענו ההגדרות \n אנא טען את הדף מחדש",
        errorUnexpected: "@@@שגיאה לא צפויה בשרת@@@: {0}",
        errorUnauthorized: "המשתמש אינו מורשה לבצע פעולה זו",
        errorPasswordExpired: 'הסיסמה שהזנת פג תוקפה. יש להזין סיסמה חדשה',
        msgFinishEditing: "יש לשמור את השורה הנוכחית לפני הוספת שורה חדשה",
        errorUserNameNotFound: "המשתמש לא קיים",
        errorIsNotExistsPhoneAndEmail: "לא מוגדר טלפון או מייל למשתמש זה. צור קשר עם התמיכה",
        lblDay1: "ראשון",
        lblDay2: "שני",
        lblDay3: "שלישי",
        lblDay4: "רביעי",
        lblDay5: "חמישי",
        lblDay6: "שישי",
        lblDay7: "שבת",
        lblDay1s: "א'",
        lblDay2s: "ב'",
        lblDay3s: "ג'",
        lblDay4s: "ד'",
        lblDay5s: "ה'",
        lblDay6s: "ו'",
        lblDay7s: "ש'",
        msgSuccess: "הפעולה הסתיימה בהצלחה",
        lblUser: "משתמש רגיל",
        btnCancelDocument: 'בטל מסמך',
        lblBy: 'ע"י',
        titleCreatedBy: 'נוצר על ידי',
        titleCreated: 'נוצר',
        titleCreatedAt: 'נוצר ב',
        titleAgo: 'לפני',
        lblAgo: 'לפני',
        lblSearch: 'חיפוש',
        lblCloseSearch: 'סגור חיפוש',
        lblColumnChooser: 'בחירת עמודות',
        lblColumnHiding: 'מצב גלילה',
        lblShowGridFilter: 'הפעל סינון מתקדם',
        lblHideGridFilter: 'הסתר סינון מתקדם',
        lblExcel: 'ייצוא לאקסל',
        lblPdf: 'ייצוא ל PDF',
        lblViewList: 'הצג בתור רשימת כרטיסיות',
        lblViewGrid: 'הצג בתור טבלה',
        lblDisplayUserName: 'שם משתמש',
        lblLastUseDate: 'תאריך פעולה אחרונה',
        lblLastUseBefore: 'פעולה אחרונה לפני',
        progressIndicator: 'מעביר נתונים.. אנא המתן',
        lblUpdated: 'עודכן',
        lblNoSorting: '- ברירת מחדל -',
        lblVersion: 'גרסה',
        lblDateIsNull: "התאריך ריק",
        f702: "פחות מדקה",
        f703: "5 דקות",
        f704: "10 דקות",
        f705: "רבע שעה",
        f706: "חצי שעה",
        f707: "פחות משעה",
        f709: "שעה וחצי",
        f710: "שעתיים פלוס",
        f711: "{0} שעות",
        f712: "יום",
        f713: "יומיים",
        f714: "{0} ימים",
        f715: "שבוע פלוס",
        f716: "שבועיים פלוס",
        f717: "{0} שבועות",
        f718: "חודש פלוס",
        f720: "חודשיים",
        f721: "{0} חודשים",
        f722: "שנה פלוס",
        f723: "שנתיים פלוס",
        f724: "{0} שנים",
        f725: "פחות מיום",
        lblOldPassword: 'סיסמה ישנה',
        lblNewPassword1: 'סיסמה חדשה',
        lblNewPassword2: 'אימות סיסמה',
        lblRecoveryPhone: 'טלפון לשליחת קוד אימות',
        lblRecoveryEmail: 'אימייל לשליחת קוד אימות',
        btnSendRecoveryCode: 'שלח קוד לאימות',
        btnCheckUserName: 'שחזר סיסמה',
        lblRecoveryType: 'אופן שיחזור סיסמה',
        lblRecoveryToken: 'קוד אימות סודי',
        btnResend: 'שלח שנית',
        btnSaveChanges: 'שמור פרטי הזדהות',
        btnGeneratePassword: 'סיסמה חדשה',
        btnCreateCredentials: 'צור משתמש',
        btnUnlockUser: 'שחרר משתמש נעול',
        lblDisplayUsername: 'שם משתמש לתצוגה',
        lblDisplayUserDescription: 'תאור משתמש לתצוגה',
        lblCredentialsNotExist: 'המשתמש טרם הוקם',
        lblPendingWelcome: 'נשלחה בקשה והמשתמש טרם הצטרף',
        titleUserInformation: 'פרטי משתמש',
        errorMaxSizeUploadError: 'חלק מהקבצים שנבחרו עוברים את הגודל המקסימאלי של {0} מגה, ולא יועלו',
        msgFileSizeRestriction: 'גודל הקובץ המקסימאלי הינה {0} מגה',
        btnSelectFiles: 'בחר קבצים',
        btnMakePhoto: 'צלם תמונה',
        lblAttachFileSize: 'גודל',
        lblFilters: 'סינונים',
        lblAt: 'ב',

        lblLoginOTPSendMethod: 'שלח סיסמה חד-פעמית באמצעות',
        lblLoginOTPEmail: 'אימייל לשליחת סיסמה חד-פעמית',
        lblLoginOTPPhone: 'טלפון לשליחת SMS עם סיסמה חד-פעמית',
        lblLoginOTPOTP: 'סיסמה חד-פעמית',
        lnkLoginByOTP: 'הזדהות באמצעות סיסמה חד-פעמית',
        msgNotificationSent: 'הסיסמה נשלחה',
        btnLoginOtpSendOtp: 'שלח סיסמה',
        lnkLoginByPassword: 'כניסה עם שם משתמש וסיסמה',

        lblApply: 'החל',
        lblTaxNumber: 'ח.פ/תעודת זהות',

        lblIsActive: 'פעיל',
        lblEmail: 'אימייל',
        lblPhone: 'טלפון',

        msgRouteNotFound: 'נתיב שגוי',
        btnReload: 'טען מחדש',
        lblHideColumn: 'הסתר עמודה',
        lblShowHiddenColumns: 'הצג את כל העמודות',

        lblName: "שם",
        lblDescription: "תיאור",

        msgLoading: "מעדכן נתונים.. אנא המתן",
        lblSentDate: "תאריך שליחה",
        lblSentBy: "נשלח על ידי",
        lblEntryID: "מספר",
        lblFromAddress: "מכתובת",
        lblFromDisplayAddress: "שם שולח",
        lblAddress: "כתובת",
        lblSubject: "כותרת",
        lblMailBody: "תוכן המייל",
        lblDeliveryOption: "אופן שליחה",
        lblStatus: "סטאטוס",
        lblCCAddress: "העתק ל",
        lblBccAddress: "העתק מוסתר ל",
        lblFailureDescription: "הודעת שגיאה",
        lblNotificationTemplate: "שם תבנית",
        lblFrom: "מ",
        lblUntil: "עד ",
        lblSessionAlmostExpiredTitle: "החיבור שלך יפוג בקרוב",
        lblSessionAlmostExpiredPrompt: "המערכת זיהתה חוסר פעילות ותנתק אותך בקרוב",
        lblSessionExpiredTitle: "החיבור למערכת פג",
        lblSessionExpiredPrompt: "החיבור שלך פג עקב חוסר פעילות. הינך מועבר לדף הכניסה",
        lblFirstDate: "תאריך ראשון",
        lblLastDate: "תאריך אחרון",
        lblDate: "תאריך",
        lblAdd: "הוסף",
        lblClear: "נקה",
        lblCompactMode: "תצוגה קומפקטית",

        lblNotificationContent: "תוכן ההתראה",
        lblGeneral: "כללי",
        lblOptions: "אפשרויות",
        lblCustom: "הגדרות מיוחדות",

        lblMFACode: "קוד חד-פעמי",
        titleMFACodeOnEmailSent: "סיסמה חד-פעמית נשלחה אלייך למייל. תזין אותו בשדה למטה",
        titleMFACodeOnPhoneSent: "סיסמה חד-פעמית נשלחה אלייך לנייד. תזין אותו בשדה למטה",

        lblMFAMethod: "אימות דו-שלבי",

        Month_1: "ינואר",
        Month_2: "פברואר",
        Month_3: "מרץ",
        Month_4: "אפריל	",
        Month_5: "מאי",
        Month_6: "יוני",
        Month_7: "יולי",
        Month_8: "אוגוסט",
        Month_9: "ספטמבר",
        Month_10: "אוקטובר",
        Month_11: "נובמבר",
        Month_12: "דצמבר",
        lblExport: "ייצוא",
        lblCredentialType: "סוג משתמש",
        lblIsRestrictByIP: "הגבל לפי כתובת IP",
        lblIsExcludeFromMFA: "החרג כתובת מ מאימות דו-שלבי",
        lblIPRangeStart: "מכתובת IP",
        lblIPRangeEnd: "עד כתובת IP",
        lblIPErrorMessage: "כתובת ה IP חייבת להיות במבנה &#34;000.000.000.000&#34;",
        msgIPRangesIsEmpty: "יש לבחור כתובת אחת לפחות",
        msgIPRangeIsEmpty: "יש להזין כתובת IP חוקית",
        msgPasswordMinLength: "הסיסמה חייבת להיות באורך מינימאלי של {0} תווים",
        msgPasswordMinCountDigits: "הסיסמה חייבת להכיל מינימום של {0} ספרות",
        msgPasswordMinCountLetters: "הסיסמה חייבת להכיל מינימום של {0} אותיות באנגלית",
        msgPasswordComplexityRequirement: "הסיסמא חייבת להיות באורך מינימאלי של {0} תווים, ולהכיל לפחות {1} ספרות ו {2} אותיות באנגלית",
        errorOnlyImageAllowed: "ניתן לבחור רק תמונות",
        btnClose: "סגור",
        lblPhoto: "תמונה",

        lblDragAndDrop: "ניתן לגרור ולשחרר קבצים לכאן",
        errorRequiredMessage: "שדה חובה",
        titleDuplicate: "שכפל",
        lblAllNotifications: "כל ההתראות",

        lblSMTPServer: "שרת SMTP",
        lblSMTPPort: "פורט SMTP",
        lblSMTPUserName: "שם משתמש ל SMTP",
        lblSMTPPassword: "סיסמא ל SMTP",
        lblSMTPUseSSL: "השתמש בחיבור SSL",
        lblSMSEndpoint: "כתובת שרת SMS",
        lblSMSUserName: "שם משתמש ל SMS",
        lblSMSPassword: "סיסמא ל SMS",
        lblSMSToken: "טוקן ל SMS",
        lblSMSEndPointIsInforU: "ספק SMS",

        titleTemplateInformation: "מידע על תבנית התראה",
        titleEmailInformation: "הגדרות מייל",
        lblFromEmail: "שלח מכתובת אימייל",
        lblFromEmailDisplay: "שלח מ שם",
        titlePhoneInformation: "הגדרות SMS",
        lblNotificationServer: "שרת התראות",
        lblFromPhone: "שלח SMS מטלפון",
        lblSMSBody: "תוכן ההודעה",
        titlePushMessagesInformation: "הגדרות התראה באפליקציה",
        lblPushMessageBody: "תוכן ההתראה",
        lblHTMLBody: "גוף HTML",
        btnSave: 'שמור',
        titleDelete: 'מחק',
        lblUseDefault: 'השתמש בברירת מחדל',
        lblNoUnreadMessages: 'אין התראות חדשות',
        lblTo: 'אל',
        lblPushMessageContent: 'תוכן ההתראה',
        lblSmsMessageContent: 'תוכן ההודעה',
        lblIsAutomatic: 'נשלח אוטומטית',
        lblSystem: 'הודעת מערכת',
        lblPopupShowStatus: 'סטאטוס התראה קופצת',
        lblEmailContent: 'תוכן אימייל',
        btnShowInEditor: 'הצג בעורך HTML',
        titleLeavePageConfirmation: 'המידע שהזנת לא יישמר. האם ברצונך להמשיך?',
        btnLogOff: 'התנתק',
        btnStayConnected: 'הישאר מחובר',
        btnGoToHomePage: 'עבור לעמוד הבית',
        lblReadDate: 'תאריך צפייה',
        msgDeleteNotificationTemplateQuestion: 'ייתכן ותבנית זו בשימוש על ידי המערכת. האם ברצונך למחוק אותה?',
        lblNotificationServerWrong: 'הגדרות שרת ההתראות אינן תקינות. בדוק אותן ונסה שנית',
        lblMIDIsMissing: "חסר קוד MID",
        lblEnterMID: "הכנס קוד MID חדש.",
        btnTestServer: 'בדוק שרת',
        btnShowPreview: "תצוגה מקדימה",
        lblIsServer: "שרת",
        lblIsClient: "קליינט",
        lblModuleName: "מודול",
        lblLogin: "Login",
        lblFramework: "Framework",
        lblOption: "הגדרה",
        lblValue: "ערך",
        lblSectionName: "סעיף",
        lblAddOption: 'הוסף הגדרה',
        msgOptionAlreadyExists: 'ההגדרה כבר קיימת',
        msgOptionEmpty: 'הגדרה {0} ריקה',
        lblBadLogin: 'הזדהות נכשלה',
        msgRemoveOption: "האם אתה בטוח שברצונך למחוק את האפשרות '{0}'?",
        titleEmailConfiguration: "תצורת אימייל",
        titleSMSConfiguration: "תצורת SMS",
        msgDeleteNotificationServerQuestion: "ניתן להשתמש בשרת הודעות באפליקציה. האם אתה בטוח שברצונך למחוק אותו?",
        msgNoData: "אין נתונים",
        lblEmailHeader: "כותרת מייל",
        lblConfigure: "הגדר",
        lblDefaultFromAddressForInforU: "Test",
        lblDefaultFromAddressForUnicel: "0509999999",
        lblInforUFromPhoneValidationTooltip: "יש להקליד מספר טלפון שנמצא ברשימת White-list במערכת או שם שולח באנגלית בלבד, עד 11 תווים",
        lblNotifications: "התראות",
        lblMinimize: "צמצם",
        lblShowMore: "הצג עוד",
        titleWhatsAppInformation: "תבנית לשליחת WhatsApp",
        lblWhatsAppBody: "תוכן הודעה ב-WhatsApp",
        lblWhatsAppApiKey: "WhatsApp Api Key",
        lblWhatsAppEndpoint: "WhatsApp Endpoint",
        titleWhatsAppConfiguration: "הגדרות WhatsApp",
        titleNotificationServerList: "שרת התראות",
        titleNotificationTemplateList: "תבנית התראות",

        lblPoweredBy: "Powered by Menahel4you.",
        titleChooseOption: "בחר אפשרות",
        titleWebAPIAllowedIPs: "WebAPI Allowed IPs",
        lblIpAddress: "כתובת IP",
        lblLoginDate: "תאריך חיבור",
        lblPrint: "הדפסה",
        lblDateFrom: 'מתאריך',
        lblDateTo: 'עד תאריך',
        msgCouldNotStartVideoError: 'מצלמה אינה זמינה',
        lblCameraModeVideo: 'וידאו',
        lblCameraModePhoto: 'תמונה',
        titlePreview: 'תצוגה מקדימה',
        msgLogoutQuestion: 'האם אתה בטוח שברצונך להתנתק?',
        lblGroupPanel: 'קיבוץ עמודות',
        lblExpandAll: 'הרחב הכל',
        lblMultiEmailError: 'ערך לא חוקי, השתמש בסמל ; על מנת להפריד בין המיילים',
        msgPhotoMinCountError: 'הספירה המינימלית היא {0}',
        msgPhotoMaxCountError: 'הספירה המקסימלית היא {0}',
        lblRestoreDefaultView: "שחזר תצוגת ברירת מחדל",
        lblStartDate: "תאריך התחלה",
        lblDuration: "משך זמן",
        lblController: "$$$Controller",
        lblMethod: "שיטה",
        lblStatusCode: "קוד סטטוס",
        lblRequestData: "נתוני בקשה",
        lblQueryString: "$$$Query string",
        lblBody: "תוכן",
        lblResponse: "הגב",
        msgTextCopied: "טקסט הועתק",
        lblCopy: "העתק",
        btnGoToLoginHistory: "עבור להיסטורית התחברויות",
        btnGoToRequestsHistory: "עבור להיסטורית בקשות",
        btnWelcomeUser: "שליחת הודעת ברוך-הבא",
        lblTestFromPhone: "מטלפון",
        lblNewValue: "ערך חדש",
        lblOldValue: "ערך ישן",
        lblFieldCaption: "שדה",
        lblDocumentCaption: " מסך",
        lblAction: "פעולה",
        lblHistoryLineAdded: "{0} - שורה מספר {1} נוספה.",
        lblHistoryLineRemoved: "{0} - שורה מספר {1} נמחקה.",
        lblHistoryLineNumber: "{0} - שורה מספר {1}",
        lblHistory: "היסטורית שינוים",
        lblHistoryNotFound: "לא נמצאו שינויים.",
        lblHistoryChangeAdded: "{0} {1} נוצר",
        lblHistoryChangeRemoved: "{0} {1} נמחק",
        msgLoadingPDF: 'טוען קובץ PDF...'
    }
};


